import * as React from "react";

import { MenuItem, Button, Typography } from "mpulse-design-system";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Menu, styled, alpha } from "@mui/material";

const AudioReviewMenu = ({
  index,
  status,
  setPopupProps,
  id,
  content,
  type,
  language,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const audioDetails = { index, id, content, type, language };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleApprove = () => {
    handleClose();
    setPopupProps({
      hidden: false,
      action: "APPROVE",
      ...audioDetails,
    });
  };

  const handleReject = () => {
    handleClose();
    setPopupProps({
      hidden: false,
      action: "REJECT",
      ...audioDetails,
    });
  };

  return (
    <>
      <StyledButton
        id="audio-actions"
        aria-controls={open ? "audio-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="outlined"
        disableElevation
        size="medium"
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
        sx={{ width: "100%", overflow: "hidden" }}
      >
        {status}
      </StyledButton>
      <Menu
        id="audio-menu"
        MenuListProps={{
          "aria-labelledby": "audio-actions",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: anchorEl && anchorEl.offsetWidth,
            ".MuiList-root": {
              padding: 0,
            },
            "& .MuiMenuItem-root": {
              height: "40px",
              "&:active": {
                backgroundColor: (theme) =>
                  alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity
                  ),
              },
              "&:hover": {
                backgroundColor: (theme) => theme.palette.primary.main,
                "& .MuiTypography-root": {
                  color: (theme) =>
                    `${theme.palette.primary.contrastText} !important`,
                },
              },
            },
          },
        }}
      >
        <MenuItem onClick={handleApprove} disableRipple>
          <Typography color="textPrimary" variant="body1">
            Approve
          </Typography>
        </MenuItem>
        <MenuItem onClick={handleReject} disableRipple>
          <Typography color="textPrimary" variant="body1">
            Reject
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

const StyledButton = styled(Button)(({ theme }) => ({
  height: "40px",
  letterSpacing: 0,
  textTransform: "unset !important",
  ...theme.typography.body1,
}));

export default AudioReviewMenu;
